import { Navigate } from "react-router-dom";
const StudioIndex = () => <Navigate to="/studio/step/1" replace />;
export default StudioIndex;
